type Listener = () => void;

export class HapticsSettingsStore {
  private hapticsEnabled = true;
  private readonly listeners = new Set<Listener>();

  public getSnapshot(): { hapticsEnabled: boolean } {
    return { hapticsEnabled: this.hapticsEnabled };
  }

  public setHapticsEnabled(enabled: boolean): void {
    if (this.hapticsEnabled === enabled) return;
    this.hapticsEnabled = enabled;
    this.emit();
  }

  public toggle(): void {
    this.setHapticsEnabled(!this.hapticsEnabled);
  }

  public subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private emit(): void {
    for (const listener of this.listeners) {
      listener();
    }
  }
}
